// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Inter, system-ui, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
  h1, h2, h3, h4, h5, h6 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}

  :root {
    --background: 210 40% 98%;
    --foreground: 222.2 84% 4.9%;

    --card: 0 0% 100%;
    --card-foreground: 222.2 84% 4.9%;

    --popover: 0 0% 100%;
    --popover-foreground: 222.2 84% 4.9%;

    --primary: 221.2 83.2% 53.3%;
    --primary-foreground: 210 40% 98%;

    --secondary: 210 40% 96.1%;
    --secondary-foreground: 222.2 47.4% 11.2%;

    --muted: 210 40% 96.1%;
    --muted-foreground: 217 19% 47%; /* #64748B */

    --accent: 210 40% 96.1%;
    --accent-foreground: 222.2 47.4% 11.2%;

    --destructive: 0 84.2% 60.2%;
    --destructive-foreground: 210 40% 98%;

    --border: 214.3 31.8% 91.4%;
    --input: 214.3 31.8% 91.4%;
    --ring: 221.2 83.2% 53.3%;

    --radius: 0.5rem;
  }

  .dark {
    --background: 222.2 84% 4.9%;
    --foreground: 210 40% 98%;

    --card: 222.2 84% 4.9%;
    --card-foreground: 210 40% 98%;

    --popover: 222.2 84% 4.9%;
    --popover-foreground: 210 40% 98%;

    --primary: 217.2 91.2% 59.8%;
    --primary-foreground: 222.2 47.4% 11.2%;

    --secondary: 217.2 32.6% 17.5%;
    --secondary-foreground: 210 40% 98%;

    --muted: 217.2 32.6% 17.5%;
    --muted-foreground: 215 20.2% 65.1%;

    --accent: 217.2 32.6% 17.5%;
    --accent-foreground: 210 40% 98%;

    --destructive: 0 62.8% 30.6%;
    --destructive-foreground: 210 40% 98%;

    --border: 217.2 32.6% 17.5%;
    --input: 217.2 32.6% 17.5%;
    --ring: 212.7 26.8% 83.9%;
  }
  * {
  border-color: hsl(var(--border));
}
  body {
  background-color: hsl(var(--background));
  color: hsl(var(--foreground));
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: "rlig" 1, "calt" 1;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 2rem;
  padding-left: 2rem;
}
@media (min-width: 1400px) {

  .container {
    max-width: 1400px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.bottom-0 {
  bottom: 0px;
}
.left-0 {
  left: 0px;
}
.left-2 {
  left: 0.5rem;
}
.left-3 {
  left: 0.75rem;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.right-0 {
  right: 0px;
}
.right-2 {
  right: 0.5rem;
}
.right-4 {
  right: 1rem;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-14 {
  top: 3.5rem;
}
.top-2 {
  top: 0.5rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.top-20 {
  top: 5rem;
}
.top-4 {
  top: 1rem;
}
.top-\\[50\\%\\] {
  top: 50%;
}
.z-10 {
  z-index: 10;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[50\\] {
  z-index: 50;
}
.z-\\[60\\] {
  z-index: 60;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-12 {
  grid-column: span 12 / span 12;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-full {
  grid-column: 1 / -1;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-auto {
  margin-right: auto;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-auto {
  margin-top: auto;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-\\[16\\/9\\] {
  aspect-ratio: 16/9;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.aspect-video {
  aspect-ratio: 16 / 9;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[var\\(--radix-select-trigger-height\\)\\] {
  height: var(--radix-select-trigger-height);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[280px\\] {
  max-height: 280px;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.max-h-\\[80vh\\] {
  max-height: 80vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[calc\\(80vh-10rem\\)\\] {
  max-height: calc(80vh - 10rem);
}
.max-h-screen {
  max-height: 100vh;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-\\[400px\\] {
  min-height: 400px;
}
.min-h-\\[60vh\\] {
  min-height: 60vh;
}
.min-h-\\[80px\\] {
  min-height: 80px;
}
.min-h-\\[calc\\(100vh-64px-4rem\\)\\] {
  min-height: calc(100vh - 64px - 4rem);
}
.min-h-screen {
  min-height: 100vh;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[280px\\] {
  width: 280px;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[44px\\] {
  width: 44px;
}
.w-full {
  width: 100%;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[8rem\\] {
  min-width: 8rem;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\] {
  min-width: var(--radix-select-trigger-width);
}
.min-w-full {
  min-width: 100%;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[150px\\] {
  max-width: 150px;
}
.max-w-\\[250px\\] {
  max-width: 250px;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.caption-bottom {
  caption-side: bottom;
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-3 {
  --tw-rotate: 3deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-grabbing {
  cursor: grabbing;
}
.cursor-help {
  cursor: help;
}
.cursor-pointer {
  cursor: pointer;
}
.touch-none {
  touch-action: none;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.select-all {
  -webkit-user-select: all;
          user-select: all;
}
.resize-none {
  resize: none;
}
.scroll-m-20 {
  scroll-margin: 5rem;
}
.list-inside {
  list-style-position: inside;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-8 {
  column-gap: 2rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity));
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-\\[16px\\] {
  border-radius: 16px;
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-\\[inherit\\] {
  border-radius: inherit;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: var(--radius);
}
.rounded-md {
  border-radius: calc(var(--radius) - 2px);
}
.rounded-sm {
  border-radius: calc(var(--radius) - 4px);
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-dashed {
  border-style: dashed;
}
.border-\\[\\#E2E8F0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity));
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity));
}
.border-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity));
}
.border-border {
  border-color: hsl(var(--border));
}
.border-current {
  border-color: currentColor;
}
.border-destructive {
  border-color: hsl(var(--destructive));
}
.border-destructive\\/50 {
  border-color: hsl(var(--destructive) / 0.5);
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity));
}
.border-input {
  border-color: hsl(var(--input));
}
.border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(255 163 0 / var(--tw-border-opacity));
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-yellow-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity));
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-t-transparent {
  border-top-color: transparent;
}
.bg-\\[\\#F8FAFC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFFFFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#ffa300\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 163 0 / var(--tw-bg-opacity));
}
.bg-accent {
  background-color: hsl(var(--accent));
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity));
}
.bg-background {
  background-color: hsl(var(--background));
}
.bg-background\\/95 {
  background-color: hsl(var(--background) / 0.95);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}
.bg-blue-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}
.bg-border {
  background-color: hsl(var(--border));
}
.bg-card {
  background-color: hsl(var(--card));
}
.bg-destructive {
  background-color: hsl(var(--destructive));
}
.bg-destructive\\/90 {
  background-color: hsl(var(--destructive) / 0.9);
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}
.bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity));
}
.bg-muted {
  background-color: hsl(var(--muted));
}
.bg-muted\\/20 {
  background-color: hsl(var(--muted) / 0.2);
}
.bg-muted\\/40 {
  background-color: hsl(var(--muted) / 0.4);
}
.bg-muted\\/50 {
  background-color: hsl(var(--muted) / 0.5);
}
.bg-muted\\/60 {
  background-color: hsl(var(--muted) / 0.6);
}
.bg-orange-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity));
}
.bg-popover {
  background-color: hsl(var(--popover));
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(255 163 0 / var(--tw-bg-opacity));
}
.bg-primary-dark {
  --tw-bg-opacity: 1;
  background-color: rgb(230 147 14 / var(--tw-bg-opacity));
}
.bg-primary\\/10 {
  background-color: rgb(255 163 0 / 0.1);
}
.bg-primary\\/5 {
  background-color: rgb(255 163 0 / 0.05);
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity));
}
.bg-secondary\\/80 {
  background-color: rgb(100 116 139 / 0.8);
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity));
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-blue-50 {
  --tw-gradient-from: #eff6ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary\\/90 {
  --tw-gradient-from: rgb(255 163 0 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 163 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-indigo-100 {
  --tw-gradient-to: #e0e7ff var(--tw-gradient-to-position);
}
.to-primary {
  --tw-gradient-to: #ffa300 var(--tw-gradient-to-position);
}
.fill-current {
  fill: currentColor;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[1px\\] {
  padding: 1px;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[0\\.3rem\\] {
  padding-left: 0.3rem;
  padding-right: 0.3rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[0\\.2rem\\] {
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pl-0 {
  padding-left: 0px;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-2\\.5 {
  padding-right: 0.625rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-middle {
  vertical-align: middle;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[1\\.1rem\\] {
  font-size: 1.1rem;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.italic {
  font-style: italic;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-none {
  line-height: 1;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.text-\\[\\#475569\\] {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}
.text-\\[\\#64748B\\] {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}
.text-\\[\\#94A3B8\\] {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity));
}
.text-\\[\\#ffa300\\] {
  --tw-text-opacity: 1;
  color: rgb(255 163 0 / var(--tw-text-opacity));
}
.text-accent-foreground {
  color: hsl(var(--accent-foreground));
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity));
}
.text-card-foreground {
  color: hsl(var(--card-foreground));
}
.text-current {
  color: currentColor;
}
.text-destructive {
  color: hsl(var(--destructive));
}
.text-destructive-foreground {
  color: hsl(var(--destructive-foreground));
}
.text-foreground {
  color: hsl(var(--foreground));
}
.text-foreground\\/50 {
  color: hsl(var(--foreground) / 0.5);
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity));
}
.text-indigo-800 {
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity));
}
.text-muted-foreground {
  color: hsl(var(--muted-foreground));
}
.text-orange-800 {
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity));
}
.text-popover-foreground {
  color: hsl(var(--popover-foreground));
}
.text-primary {
  --tw-text-opacity: 1;
  color: rgb(255 163 0 / var(--tw-text-opacity));
}
.text-primary-foreground {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-purple-800 {
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity));
}
.text-secondary-foreground {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity));
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-90 {
  opacity: 0.9;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-black {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity));
}
.ring-primary {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 163 0 / var(--tw-ring-opacity));
}
.ring-opacity-5 {
  --tw-ring-opacity: 0.05;
}
.ring-offset-background {
  --tw-ring-offset-color: hsl(var(--background));
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter {
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

/* Aplicando cores globalmente para headings */
h1, h2, h3, h4, h5, h6 {
  color: #475569 !important;
}

/* Aplicando a fonte Ubuntu globalmente */
html, body {
  font-family: 'Ubuntu', sans-serif;
}

/* Cor padrão para todos os headings */
h1, h2, h3, h4, h5, h6 {
  color: #475569;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

.btn-primary {
  background-color: #ffa300;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #e6930e;
}

.btn-secondary {
  background-color: white;
  color: #374151;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  border: 1px solid #d1d5db;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-secondary:hover {
  background-color: #f3f4f6;
}

.input {
  width: 100%;
  padding: 0.5rem;
  border-radius: 0.5rem;
  border: 1px solid #d1d5db;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.25rem;
}

.form-group {
  margin-bottom: 1rem;
}

.file\\:border-0::file-selector-button {
  border-width: 0px;
}

.file\\:bg-transparent::file-selector-button {
  background-color: transparent;
}

.file\\:text-sm::file-selector-button {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.file\\:font-medium::file-selector-button {
  font-weight: 500;
}

.placeholder\\:text-muted-foreground::placeholder {
  color: hsl(var(--muted-foreground));
}

.after\\:ml-1::after {
  content: var(--tw-content);
  margin-left: 0.25rem;
}

.after\\:text-red-500::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}

.after\\:content-\\[\\"\\*\\"\\]::after {
  --tw-content: "*";
  content: var(--tw-content);
}

.first\\:mt-0:first-child {
  margin-top: 0px;
}

.hover\\:border-primary:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 163 0 / var(--tw-border-opacity));
}

.hover\\:border-primary\\/20:hover {
  border-color: rgb(255 163 0 / 0.2);
}

.hover\\:border-red-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity));
}

.hover\\:border-yellow-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity));
}

.hover\\:bg-accent:hover {
  background-color: hsl(var(--accent));
}

.hover\\:bg-accent\\/40:hover {
  background-color: hsl(var(--accent) / 0.4);
}

.hover\\:bg-accent\\/50:hover {
  background-color: hsl(var(--accent) / 0.5);
}

.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity));
}

.hover\\:bg-destructive\\/10:hover {
  background-color: hsl(var(--destructive) / 0.1);
}

.hover\\:bg-destructive\\/80:hover {
  background-color: hsl(var(--destructive) / 0.8);
}

.hover\\:bg-destructive\\/90:hover {
  background-color: hsl(var(--destructive) / 0.9);
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}

.hover\\:bg-green-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity));
}

.hover\\:bg-muted\\/50:hover {
  background-color: hsl(var(--muted) / 0.5);
}

.hover\\:bg-primary-dark:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(230 147 14 / var(--tw-bg-opacity));
}

.hover\\:bg-primary\\/80:hover {
  background-color: rgb(255 163 0 / 0.8);
}

.hover\\:bg-primary\\/90:hover {
  background-color: rgb(255 163 0 / 0.9);
}

.hover\\:bg-red-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity));
}

.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}

.hover\\:bg-secondary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity));
}

.hover\\:bg-secondary\\/80:hover {
  background-color: rgb(100 116 139 / 0.8);
}

.hover\\:pl-0:hover {
  padding-left: 0px;
}

.hover\\:text-accent-foreground:hover {
  color: hsl(var(--accent-foreground));
}

.hover\\:text-blue-500:hover {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}

.hover\\:text-foreground:hover {
  color: hsl(var(--foreground));
}

.hover\\:text-gray-500:hover {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}

.hover\\:text-primary:hover {
  --tw-text-opacity: 1;
  color: rgb(255 163 0 / var(--tw-text-opacity));
}

.hover\\:text-primary-dark:hover {
  --tw-text-opacity: 1;
  color: rgb(230 147 14 / var(--tw-text-opacity));
}

.hover\\:text-primary-foreground:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.hover\\:text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}

.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}

.focus\\:bg-accent:focus {
  background-color: hsl(var(--accent));
}

.focus\\:text-accent-foreground:focus {
  color: hsl(var(--accent-foreground));
}

.focus\\:opacity-100:focus {
  opacity: 1;
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
}

.focus\\:ring-ring:focus {
  --tw-ring-color: hsl(var(--ring));
}

.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-ring:focus-visible {
  --tw-ring-color: hsl(var(--ring));
}

.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-offset-background:focus-visible {
  --tw-ring-offset-color: hsl(var(--background));
}

.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40 {
  border-color: hsl(var(--muted) / 0.4);
}

.group.destructive .group-\\[\\.destructive\\]\\:text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover {
  border-color: hsl(var(--destructive) / 0.3);
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover {
  background-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover {
  color: hsl(var(--destructive-foreground));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover {
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus {
  --tw-ring-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus {
  --tw-ring-offset-color: #dc2626;
}

.peer:disabled ~ .peer-disabled\\:cursor-not-allowed {
  cursor: not-allowed;
}

.peer:disabled ~ .peer-disabled\\:opacity-70 {
  opacity: 0.7;
}

.aria-selected\\:bg-accent[aria-selected="true"] {
  background-color: hsl(var(--accent));
}

.aria-selected\\:text-accent-foreground[aria-selected="true"] {
  color: hsl(var(--accent-foreground));
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled] {
  pointer-events: none;
}

.data-\\[side\\=bottom\\]\\:translate-y-1[data-side=bottom] {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=left\\]\\:-translate-x-1[data-side=left] {
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=right\\]\\:translate-x-1[data-side=right] {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=top\\]\\:-translate-y-1[data-side=top] {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=checked\\]\\:translate-x-5[data-state=checked] {
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state=unchecked] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe=cancel] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe=end] {
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe=move] {
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[state\\=active\\]\\:bg-background[data-state=active] {
  background-color: hsl(var(--background));
}

.data-\\[state\\=checked\\]\\:bg-primary[data-state=checked] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 163 0 / var(--tw-bg-opacity));
}

.data-\\[state\\=open\\]\\:bg-accent[data-state=open] {
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:bg-secondary[data-state=open] {
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity));
}

.data-\\[state\\=selected\\]\\:bg-muted[data-state=selected] {
  background-color: hsl(var(--muted));
}

.data-\\[state\\=unchecked\\]\\:bg-input[data-state=unchecked] {
  background-color: hsl(var(--input));
}

.data-\\[state\\=active\\]\\:text-foreground[data-state=active] {
  color: hsl(var(--foreground));
}

.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state=checked] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.data-\\[state\\=open\\]\\:text-muted-foreground[data-state=open] {
  color: hsl(var(--muted-foreground));
}

.data-\\[disabled\\]\\:opacity-50[data-disabled] {
  opacity: 0.5;
}

.data-\\[state\\=active\\]\\:shadow-sm[data-state=active] {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[swipe\\=move\\]\\:transition-none[data-swipe=move] {
  transition-property: none;
}

@supports (backdrop-filter: var(--tw)) {

  .supports-\\[backdrop-filter\\]\\:bg-background\\/60 {
    background-color: hsl(var(--background) / 0.6);
  }
}

:is(.dark .dark\\:border-destructive) {
  border-color: hsl(var(--destructive));
}

:is(.dark .dark\\:bg-blue-900) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-gray-800) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-green-900) {
  --tw-bg-opacity: 1;
  background-color: rgb(20 83 45 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-yellow-900) {
  --tw-bg-opacity: 1;
  background-color: rgb(113 63 18 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:text-blue-300) {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-gray-400) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-green-300) {
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-white) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-yellow-300) {
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity));
}

@media (min-width: 640px) {

  .sm\\:bottom-0 {
    bottom: 0px;
  }

  .sm\\:right-0 {
    right: 0px;
  }

  .sm\\:top-auto {
    top: auto;
  }

  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .sm\\:w-24 {
    width: 6rem;
  }

  .sm\\:w-80 {
    width: 20rem;
  }

  .sm\\:max-w-\\[500px\\] {
    max-width: 500px;
  }

  .sm\\:max-w-\\[600px\\] {
    max-width: 600px;
  }

  .sm\\:max-w-\\[700px\\] {
    max-width: 700px;
  }

  .sm\\:max-w-md {
    max-width: 28rem;
  }

  .sm\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:rounded-lg {
    border-radius: var(--radius);
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (min-width: 768px) {

  .md\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .md\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .md\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .md\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .md\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:w-64 {
    width: 16rem;
  }

  .md\\:max-w-\\[420px\\] {
    max-width: 420px;
  }

  .md\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .md\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .md\\:pb-8 {
    padding-bottom: 2rem;
  }

  .md\\:pl-0 {
    padding-left: 0px;
  }

  .md\\:pr-8 {
    padding-right: 2rem;
  }

  .md\\:pt-0 {
    padding-top: 0px;
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1024px) {

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }
}

.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]) {
  padding-right: 0px;
}

.\\[\\&\\>span\\]\\:line-clamp-1>span {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div {
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\>svg\\]\\:absolute>svg {
  position: absolute;
}

.\\[\\&\\>svg\\]\\:left-4>svg {
  left: 1rem;
}

.\\[\\&\\>svg\\]\\:top-4>svg {
  top: 1rem;
}

.\\[\\&\\>svg\\]\\:text-destructive>svg {
  color: hsl(var(--destructive));
}

.\\[\\&\\>svg\\]\\:text-foreground>svg {
  color: hsl(var(--foreground));
}

.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~* {
  padding-left: 1.75rem;
}

.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr {
  border-bottom-width: 0px;
}

.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading] {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading] {
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading] {
  font-weight: 500;
}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading] {
  color: hsl(var(--muted-foreground));
}

.\\[\\&_p\\]\\:leading-relaxed p {
  line-height: 1.625;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAA0B,CAA1B;;;CAA0B;;AAA1B;;;EAAA,sBAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,mBAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;EAAA,gBAA0B;AAAA;;AAA1B;;;;;;;CAA0B;;AAA1B;EAAA,gBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B,EAA1B,MAA0B;EAA1B,WAA0B,EAA1B,MAA0B;EAA1B,yCAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,yCAA0B;UAA1B,iCAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;EAAA,kBAA0B;EAA1B,oBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,mBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;;;EAAA,+GAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,cAA0B;EAA1B,cAA0B;EAA1B,kBAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;EAAA,WAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;EAA1B,yBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;EAAA,oBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gCAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,SAA0B,EAA1B,MAA0B;EAA1B,UAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,oBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;;;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,aAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,YAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,6BAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,aAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,kBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;;;;;;;;EAAA,SAA0B;AAAA;;AAA1B;EAAA,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;;EAAA,gBAA0B;EAA1B,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;;;;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;EAA1B,YAA0B;AAAA;;AAA1B,wEAA0B;AAA1B;EAAA,aAA0B;AAAA;EAA1B;EAAA,oBAA0B;EAA1B,8CAAA;AAA0B;;EAA1B;IAAA,yBAA0B;IAA1B,4BAA0B;;IAA1B,iBAA0B;IAA1B,iCAA0B;;IAA1B,oBAA0B;IAA1B,oCAA0B;;IAA1B,4BAA0B;IAA1B,iCAA0B;;IAA1B,0BAA0B;IAA1B,yCAA0B;;IAA1B,sBAA0B;IAA1B,+BAA0B,EAA1B,YAA0B;;IAA1B,uBAA0B;IAA1B,sCAA0B;;IAA1B,4BAA0B;IAA1B,qCAA0B;;IAA1B,2BAA0B;IAA1B,0BAA0B;IAA1B,yBAA0B;;IAA1B,gBAA0B;EAAA;;EAA1B;IAAA,4BAA0B;IAA1B,yBAA0B;;IAA1B,sBAA0B;IAA1B,8BAA0B;;IAA1B,yBAA0B;IAA1B,iCAA0B;;IAA1B,4BAA0B;IAA1B,uCAA0B;;IAA1B,8BAA0B;IAA1B,mCAA0B;;IAA1B,0BAA0B;IAA1B,mCAA0B;;IAA1B,2BAA0B;IAA1B,gCAA0B;;IAA1B,4BAA0B;IAA1B,qCAA0B;;IAA1B,2BAA0B;IAA1B,0BAA0B;IAA1B,yBAA0B;EAAA;EAA1B;EAAA,gCAAA;AAA0B;EAA1B;EAAA,wCAA0B;EAA1B,6BAA0B;IAA1B,mCAA0B;IAA1B,kCAA0B;IAA1B,yCAAA;AAA0B;;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAAA;AAA0B;;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAAA;AAA0B;AAC1B;EAAA,WAAgC;EAAhC,kBAAgC;EAAhC,iBAAgC;EAAhC,mBAAgC;EAAhC,kBAAA;AAAgC;AAAhC;;EAAA;IAAA,iBAAA;EAAgC;AAAA;AAChC;EAAA,kBAA+B;EAA/B,UAA+B;EAA/B,WAA+B;EAA/B,UAA+B;EAA/B,YAA+B;EAA/B,gBAA+B;EAA/B,sBAA+B;EAA/B,mBAA+B;EAA/B,eAAA;AAA+B;AAA/B;EAAA,oBAAA;AAA+B;AAA/B;EAAA,oBAAA;AAA+B;AAA/B;EAAA,eAAA;AAA+B;AAA/B;EAAA,kBAAA;AAA+B;AAA/B;EAAA,kBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,UAAA;AAA+B;AAA/B;EAAA,SAA+B;EAA/B,UAAA;AAA+B;AAA/B;EAAA,QAA+B;EAA/B,WAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,SAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,aAAA;AAA+B;AAA/B;EAAA,SAAA;AAA+B;AAA/B;EAAA,UAAA;AAA+B;AAA/B;EAAA,aAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,QAAA;AAA+B;AAA/B;EAAA,QAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,aAAA;AAA+B;AAA/B;EAAA,SAAA;AAA+B;AAA/B;EAAA,SAAA;AAA+B;AAA/B;EAAA,QAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,4BAAA;AAA+B;AAA/B;EAAA,8BAAA;AAA+B;AAA/B;EAAA,4BAAA;AAA+B;AAA/B;EAAA,mBAAA;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B,sBAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,kBAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,kBAAA;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B,sBAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,qBAAA;AAA+B;AAA/B;EAAA,sBAAA;AAA+B;AAA/B;EAAA,qBAAA;AAA+B;AAA/B;EAAA,sBAAA;AAA+B;AAA/B;EAAA,mBAAA;AAA+B;AAA/B;EAAA,qBAAA;AAA+B;AAA/B;EAAA,mBAAA;AAA+B;AAA/B;EAAA,oBAAA;AAA+B;AAA/B;EAAA,mBAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,qBAAA;AAA+B;AAA/B;EAAA,oBAAA;AAA+B;AAA/B;EAAA,qBAAA;AAA+B;AAA/B;EAAA,kBAAA;AAA+B;AAA/B;EAAA,eAAA;AAA+B;AAA/B;EAAA,oBAAA;AAA+B;AAA/B;EAAA,mBAAA;AAA+B;AAA/B;EAAA,kBAAA;AAA+B;AAA/B;EAAA,kBAAA;AAA+B;AAA/B;EAAA,mBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,kBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,cAAA;AAA+B;AAA/B;EAAA,qBAAA;AAA+B;AAA/B;EAAA,eAAA;AAA+B;AAA/B;EAAA,aAAA;AAA+B;AAA/B;EAAA,oBAAA;AAA+B;AAA/B;EAAA,cAAA;AAA+B;AAA/B;EAAA,aAAA;AAA+B;AAA/B;EAAA,aAAA;AAA+B;AAA/B;EAAA,kBAAA;AAA+B;AAA/B;EAAA,mBAAA;AAA+B;AAA/B;EAAA,oBAAA;AAA+B;AAA/B;EAAA,cAAA;AAA+B;AAA/B;EAAA,eAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,cAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,eAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,aAAA;AAA+B;AAA/B;EAAA,aAAA;AAA+B;AAA/B;EAAA,eAAA;AAA+B;AAA/B;EAAA,cAAA;AAA+B;AAA/B;EAAA,aAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,eAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,0CAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,8BAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,qCAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,aAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,aAAA;AAA+B;AAA/B;EAAA,eAAA;AAA+B;AAA/B;EAAA,cAAA;AAA+B;AAA/B;EAAA,eAAA;AAA+B;AAA/B;EAAA,UAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,cAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,aAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,cAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,UAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,cAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,eAAA;AAA+B;AAA/B;EAAA,4CAAA;AAA+B;AAA/B;EAAA,eAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,SAAA;AAA+B;AAA/B;EAAA,cAAA;AAA+B;AAA/B;EAAA,cAAA;AAA+B;AAA/B;EAAA,oBAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,+LAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,+LAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,+LAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,+LAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,kBAA+B;EAA/B,+LAAA;AAA+B;AAA/B;EAAA,+LAAA;AAA+B;AAA/B;;EAAA;IAAA,WAAA;EAA+B;AAAA;AAA/B;EAAA,yDAAA;AAA+B;AAA/B;;EAAA;IAAA,yBAAA;EAA+B;AAAA;AAA/B;EAAA,kCAAA;AAA+B;AAA/B;EAAA,eAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,eAAA;AAA+B;AAA/B;EAAA,kBAAA;AAA+B;AAA/B;EAAA,yBAA+B;UAA/B,iBAAA;AAA+B;AAA/B;EAAA,wBAA+B;UAA/B,gBAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,mBAAA;AAA+B;AAA/B;EAAA,2BAAA;AAA+B;AAA/B;EAAA,wBAAA;AAA+B;AAA/B;EAAA,qBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gDAAA;AAA+B;AAA/B;EAAA,iDAAA;AAA+B;AAA/B;EAAA,gDAAA;AAA+B;AAA/B;EAAA,gDAAA;AAA+B;AAA/B;EAAA,gDAAA;AAA+B;AAA/B;EAAA,mBAAA;AAA+B;AAA/B;EAAA,sBAAA;AAA+B;AAA/B;EAAA,8BAAA;AAA+B;AAA/B;EAAA,eAAA;AAA+B;AAA/B;EAAA,uBAAA;AAA+B;AAA/B;EAAA,mBAAA;AAA+B;AAA/B;EAAA,2BAAA;AAA+B;AAA/B;EAAA,yBAAA;AAA+B;AAA/B;EAAA,uBAAA;AAA+B;AAA/B;EAAA,8BAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,SAAA;AAA+B;AAA/B;EAAA,WAAA;AAA+B;AAA/B;EAAA,SAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,eAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,aAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,sDAA+B;EAA/B,+DAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,uDAA+B;EAA/B,gEAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,oDAA+B;EAA/B,6DAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,sDAA+B;EAA/B,+DAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,2DAA+B;EAA/B,oDAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,gEAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+DAA+B;EAA/B,wDAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,gEAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,8DAA+B;EAA/B,uDAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+DAA+B;EAA/B,wDAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,4DAA+B;EAA/B,qDAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,8DAA+B;EAA/B,uDAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,4DAA+B;EAA/B,qDAAA;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,kEAA+B;EAA/B,2DAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,cAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,kBAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,uBAA+B;EAA/B,mBAAA;AAA+B;AAA/B;EAAA,mBAAA;AAA+B;AAA/B;EAAA,qBAAA;AAA+B;AAA/B;EAAA,qBAAA;AAA+B;AAA/B;EAAA,sBAAA;AAA+B;AAA/B;EAAA,mBAAA;AAA+B;AAA/B;EAAA,kBAAA;AAA+B;AAA/B;EAAA,sBAAA;AAA+B;AAA/B;EAAA,qBAAA;AAA+B;AAA/B;EAAA,4BAAA;AAA+B;AAA/B;EAAA,wCAAA;AAA+B;AAA/B;EAAA,wCAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,wBAAA;AAA+B;AAA/B;EAAA,wBAAA;AAA+B;AAA/B;EAAA,sBAAA;AAA+B;AAA/B;EAAA,sBAAA;AAA+B;AAA/B;EAAA,uBAAA;AAA+B;AAA/B;EAAA,qBAAA;AAA+B;AAA/B;EAAA,oBAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,uDAAA;AAA+B;AAA/B;EAAA,gCAAA;AAA+B;AAA/B;EAAA,0BAAA;AAA+B;AAA/B;EAAA,qCAAA;AAA+B;AAA/B;EAAA,2CAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,+BAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,uDAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,uDAAA;AAA+B;AAA/B;EAAA,yBAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,8BAAA;AAA+B;AAA/B;EAAA,6BAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uDAAA;AAA+B;AAA/B;EAAA,oCAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wDAAA;AAA+B;AAA/B;EAAA,wCAAA;AAA+B;AAA/B;EAAA,+CAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,mDAAA;AAA+B;AAA/B;EAAA,kCAAA;AAA+B;AAA/B;EAAA,kCAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uDAAA;AAA+B;AAA/B;EAAA,oCAAA;AAA+B;AAA/B;EAAA,kCAAA;AAA+B;AAA/B;EAAA,yCAAA;AAA+B;AAA/B;EAAA,+CAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uDAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uDAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,mCAAA;AAA+B;AAA/B;EAAA,yCAAA;AAA+B;AAA/B;EAAA,yCAAA;AAA+B;AAA/B;EAAA,yCAAA;AAA+B;AAA/B;EAAA,yCAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,qCAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uDAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,wDAAA;AAA+B;AAA/B;EAAA,sCAAA;AAA+B;AAA/B;EAAA,uCAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,uDAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,wCAAA;AAA+B;AAA/B;EAAA,6BAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,wCAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,yDAAA;AAA+B;AAA/B;EAAA,oBAAA;AAA+B;AAA/B;EAAA,4EAAA;AAA+B;AAA/B;EAAA,qEAAA;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,qEAA+B;EAA/B,mEAAA;AAA+B;AAA/B;EAAA,yEAA+B;EAA/B,mEAA+B;EAA/B,mEAAA;AAA+B;AAA/B;EAAA,wDAAA;AAA+B;AAA/B;EAAA,wDAAA;AAA+B;AAA/B;EAAA,kBAAA;AAA+B;AAA/B;EAAA,mBAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,eAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,aAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,eAAA;AAA+B;AAA/B;EAAA,aAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,qBAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,uBAAA;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B,sBAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,mBAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,qBAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,mBAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,qBAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,mBAAA;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B,wBAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,uBAAA;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B,wBAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,oBAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,oBAAA;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B,sBAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,uBAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,oBAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,uBAAA;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B,sBAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,oBAAA;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B,sBAAA;AAA+B;AAA/B;EAAA,sBAAA;AAA+B;AAA/B;EAAA,oBAAA;AAA+B;AAA/B;EAAA,sBAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,oBAAA;AAA+B;AAA/B;EAAA,oBAAA;AAA+B;AAA/B;EAAA,sBAAA;AAA+B;AAA/B;EAAA,kBAAA;AAA+B;AAA/B;EAAA,oBAAA;AAA+B;AAA/B;EAAA,kBAAA;AAA+B;AAA/B;EAAA,qBAAA;AAA+B;AAA/B;EAAA,qBAAA;AAA+B;AAA/B;EAAA,qBAAA;AAA+B;AAA/B;EAAA,uBAAA;AAA+B;AAA/B;EAAA,sBAAA;AAA+B;AAA/B;EAAA,qBAAA;AAA+B;AAA/B;EAAA,mBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,mBAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,mBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,kBAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,sBAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,iBAAA;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B,oBAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,mBAAA;AAA+B;AAA/B;EAAA,iBAAA;AAA+B;AAA/B;EAAA,eAA+B;EAA/B,mBAAA;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B,oBAAA;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B,oBAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,oBAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,iBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,gBAAA;AAA+B;AAA/B;EAAA,yBAAA;AAA+B;AAA/B;EAAA,kBAAA;AAA+B;AAA/B;EAAA,oBAAA;AAA+B;AAA/B;EAAA,cAAA;AAA+B;AAA/B;EAAA,wBAAA;AAA+B;AAA/B;EAAA,sBAAA;AAA+B;AAA/B;EAAA,qBAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,8CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,gDAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,gDAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,8CAAA;AAA+B;AAA/B;EAAA,oCAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,+CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,0CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,8CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,8CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,8CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,8CAAA;AAA+B;AAA/B;EAAA,kCAAA;AAA+B;AAA/B;EAAA,mBAAA;AAA+B;AAA/B;EAAA,8BAAA;AAA+B;AAA/B;EAAA,yCAAA;AAA+B;AAA/B;EAAA,6BAAA;AAA+B;AAA/B;EAAA,mCAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,gDAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,gDAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,6CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,8CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,8CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,8CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,8CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,8CAAA;AAA+B;AAA/B;EAAA,mCAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,8CAAA;AAA+B;AAA/B;EAAA,qCAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,8CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,gDAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,+CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,gDAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,8CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,8CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,8CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,8CAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,gDAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,gDAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,8CAAA;AAA+B;AAA/B;EAAA,+BAAA;AAA+B;AAA/B;EAAA,0BAAA;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B,uDAAA;AAA+B;AAA/B;EAAA,UAAA;AAA+B;AAA/B;EAAA,UAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,YAAA;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,8FAA+B;EAA/B,uGAAA;AAA+B;AAA/B;EAAA,gDAA+B;EAA/B,6DAA+B;EAA/B,uGAAA;AAA+B;AAA/B;EAAA,+EAA+B;EAA/B,mGAA+B;EAA/B,uGAAA;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,iGAA+B;EAA/B,uGAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,8BAA+B;EAA/B,uGAAA;AAA+B;AAA/B;EAAA,0CAA+B;EAA/B,uDAA+B;EAA/B,uGAAA;AAA+B;AAA/B;EAAA,gFAA+B;EAA/B,oGAA+B;EAA/B,uGAAA;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B,mBAAA;AAA+B;AAA/B;EAAA,oBAAA;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B,4FAAA;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B,4FAAA;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B,4FAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,oDAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B,wDAAA;AAA+B;AAA/B;EAAA,uBAAA;AAA+B;AAA/B;EAAA,8CAAA;AAA+B;AAA/B;EAAA,iLAAA;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B,uQAAA;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B,uQAAA;AAA+B;AAA/B;EAAA,uQAAA;AAA+B;AAA/B;EAAA,wJAA+B;EAA/B,wDAA+B;EAA/B,0BAAA;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,wDAA+B;EAA/B,0BAAA;AAA+B;AAA/B;EAAA,+FAA+B;EAA/B,wDAA+B;EAA/B,0BAAA;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B,wDAA+B;EAA/B,0BAAA;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B,wDAA+B;EAA/B,0BAAA;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B,wDAA+B;EAA/B,0BAAA;AAA+B;AAA/B;EAAA,0BAAA;AAA+B;AAA/B;EAAA,0BAAA;AAA+B;AAA/B;EAAA,0BAAA;AAA+B;AAA/B;EAAA,0BAAA;AAA+B;AAA/B;EAAA,wDAAA;AAA+B;AAA/B;EAAA,sDAAA;AAA+B;;AAE/B,8CAA8C;AAC9C;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,iCAAiC;AACnC;;AAEA,sCAAsC;AACtC;EACE,cAAc;AAChB;;AAkFA;EACE,+EAA+E;AACjF;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AA3JA;EAAA,iBAAA;AA4JA;;AA5JA;EAAA,6BAAA;AA4JA;;AA5JA;EAAA,mBA4JA;EA5JA,oBAAA;AA4JA;;AA5JA;EAAA,gBAAA;AA4JA;;AA5JA;EAAA,mCAAA;AA4JA;;AA5JA;EAAA,0BA4JA;EA5JA,oBAAA;AA4JA;;AA5JA;EAAA,0BA4JA;EA5JA,oBA4JA;EA5JA,8CAAA;AA4JA;;AA5JA;EAAA,iBA4JA;EA5JA,0BAAA;AA4JA;;AA5JA;EAAA,eAAA;AA4JA;;AA5JA;EAAA,sBA4JA;EA5JA,uDAAA;AA4JA;;AA5JA;EAAA,kCAAA;AA4JA;;AA5JA;EAAA,sBA4JA;EA5JA,yDAAA;AA4JA;;AA5JA;EAAA,sBA4JA;EA5JA,wDAAA;AA4JA;;AA5JA;EAAA,oCAAA;AA4JA;;AA5JA;EAAA,0CAAA;AA4JA;;AA5JA;EAAA,0CAAA;AA4JA;;AA5JA;EAAA,kBA4JA;EA5JA,uDAAA;AA4JA;;AA5JA;EAAA,+CAAA;AA4JA;;AA5JA;EAAA,+CAAA;AA4JA;;AA5JA;EAAA,+CAAA;AA4JA;;AA5JA;EAAA,kBA4JA;EA5JA,yDAAA;AA4JA;;AA5JA;EAAA,kBA4JA;EA5JA,yDAAA;AA4JA;;AA5JA;EAAA,kBA4JA;EA5JA,yDAAA;AA4JA;;AA5JA;EAAA,kBA4JA;EA5JA,yDAAA;AA4JA;;AA5JA;EAAA,yCAAA;AA4JA;;AA5JA;EAAA,kBA4JA;EA5JA,wDAAA;AA4JA;;AA5JA;EAAA,sCAAA;AA4JA;;AA5JA;EAAA,sCAAA;AA4JA;;AA5JA;EAAA,kBA4JA;EA5JA,yDAAA;AA4JA;;AA5JA;EAAA,kBA4JA;EA5JA,yDAAA;AA4JA;;AA5JA;EAAA,kBA4JA;EA5JA,yDAAA;AA4JA;;AA5JA;EAAA,wCAAA;AA4JA;;AA5JA;EAAA,iBAAA;AA4JA;;AA5JA;EAAA,oCAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,+CAAA;AA4JA;;AA5JA;EAAA,6BAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,gDAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,6CAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,8CAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,+CAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,gDAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,8CAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,8CAAA;AA4JA;;AA5JA;EAAA,+BAAA;AA4JA;;AA5JA;EAAA,UAAA;AA4JA;;AA5JA;EAAA,+EA4JA;EA5JA,mGA4JA;EA5JA,uGAAA;AA4JA;;AA5JA;EAAA,6EA4JA;EA5JA,iGA4JA;EA5JA,uGAAA;AA4JA;;AA5JA;EAAA,sBA4JA;EA5JA,wDAAA;AA4JA;;AA5JA;EAAA,oCAAA;AA4JA;;AA5JA;EAAA,oCAAA;AA4JA;;AA5JA;EAAA,UAAA;AA4JA;;AA5JA;EAAA,8BA4JA;EA5JA,mBAAA;AA4JA;;AA5JA;EAAA,2GA4JA;EA5JA,yGA4JA;EA5JA,4FAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,yDAAA;AA4JA;;AA5JA;EAAA,iCAAA;AA4JA;;AA5JA;EAAA,2BAAA;AA4JA;;AA5JA;EAAA,8BA4JA;EA5JA,mBAAA;AA4JA;;AA5JA;EAAA,2GA4JA;EA5JA,yGA4JA;EA5JA,4FAAA;AA4JA;;AA5JA;EAAA,iCAAA;AA4JA;;AA5JA;EAAA,2BAAA;AA4JA;;AA5JA;EAAA,8CAAA;AA4JA;;AA5JA;EAAA,oBAAA;AA4JA;;AA5JA;EAAA,mBAAA;AA4JA;;AA5JA;EAAA,YAAA;AA4JA;;AA5JA;EAAA,UAAA;AA4JA;;AA5JA;EAAA,qCAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,gDAAA;AA4JA;;AA5JA;EAAA,2CAAA;AA4JA;;AA5JA;EAAA,yCAAA;AA4JA;;AA5JA;EAAA,yCAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,gDAAA;AA4JA;;AA5JA;EAAA,wCAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,0DAAA;AA4JA;;AA5JA;EAAA,+BAAA;AA4JA;;AA5JA;EAAA,mBAAA;AA4JA;;AA5JA;EAAA,YAAA;AA4JA;;AA5JA;EAAA,oCAAA;AA4JA;;AA5JA;EAAA,oCAAA;AA4JA;;AA5JA;EAAA,oBAAA;AA4JA;;AA5JA;EAAA,yBA4JA;EA5JA,+LAAA;AA4JA;;AA5JA;EAAA,0BA4JA;EA5JA,+LAAA;AA4JA;;AA5JA;EAAA,yBA4JA;EA5JA,+LAAA;AA4JA;;AA5JA;EAAA,0BA4JA;EA5JA,+LAAA;AA4JA;;AA5JA;EAAA,yBA4JA;EA5JA,+LAAA;AA4JA;;AA5JA;EAAA,qBA4JA;EA5JA,+LAAA;AA4JA;;AA5JA;EAAA,qBA4JA;EA5JA,+LAAA;AA4JA;;AA5JA;EAAA,gDA4JA;EA5JA,+LAAA;AA4JA;;AA5JA;EAAA,iDA4JA;EA5JA,+LAAA;AA4JA;;AA5JA;EAAA,wCAAA;AA4JA;;AA5JA;EAAA,kBA4JA;EA5JA,uDAAA;AA4JA;;AA5JA;EAAA,oCAAA;AA4JA;;AA5JA;EAAA,kBA4JA;EA5JA,yDAAA;AA4JA;;AA5JA;EAAA,mCAAA;AA4JA;;AA5JA;EAAA,mCAAA;AA4JA;;AA5JA;EAAA,6BAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,gDAAA;AA4JA;;AA5JA;EAAA,mCAAA;AA4JA;;AA5JA;EAAA,YAAA;AA4JA;;AA5JA;EAAA,0CA4JA;EA5JA,uDA4JA;EA5JA,uGAAA;AA4JA;;AA5JA;EAAA,yBAAA;AA4JA;;AA5JA;;EAAA;IAAA,8CAAA;EA4JA;AAAA;;AA5JA;EAAA,qCAAA;AA4JA;;AA5JA;EAAA,kBA4JA;EA5JA,uDAAA;AA4JA;;AA5JA;EAAA,kBA4JA;EA5JA,sDAAA;AA4JA;;AA5JA;EAAA,kBA4JA;EA5JA,sDAAA;AA4JA;;AA5JA;EAAA,kBA4JA;EA5JA,uDAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,gDAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,gDAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,gDAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,gDAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,+CAAA;AA4JA;;AA5JA;;EAAA;IAAA,WAAA;EA4JA;;EA5JA;IAAA,UAAA;EA4JA;;EA5JA;IAAA,SAAA;EA4JA;;EA5JA;IAAA,4BAAA;EA4JA;;EA5JA;IAAA,WAAA;EA4JA;;EA5JA;IAAA,YAAA;EA4JA;;EA5JA;IAAA,gBAAA;EA4JA;;EA5JA;IAAA,gBAAA;EA4JA;;EA5JA;IAAA,gBAAA;EA4JA;;EA5JA;IAAA,gBAAA;EA4JA;;EA5JA;IAAA,iDAAA;EA4JA;;EA5JA;IAAA,gDAAA;EA4JA;;EA5JA;IAAA,gDAAA;EA4JA;;EA5JA;IAAA,gDAAA;EA4JA;;EA5JA;IAAA,gDAAA;EA4JA;;EA5JA;IAAA,mBAAA;EA4JA;;EA5JA;IAAA,sBAAA;EA4JA;;EA5JA;IAAA,mBAAA;EA4JA;;EA5JA;IAAA,yBAAA;EA4JA;;EA5JA;IAAA,8BAAA;EA4JA;;EA5JA;IAAA,uBA4JA;IA5JA,sDA4JA;IA5JA,+DAAA;EA4JA;;EA5JA;IAAA,4BAAA;EA4JA;;EA5JA;IAAA,gBAAA;EA4JA;;EA5JA;IAAA,mBA4JA;IA5JA,oBAAA;EA4JA;AAAA;;AA5JA;;EAAA;IAAA,4BAAA;EA4JA;;EA5JA;IAAA,4BAAA;EA4JA;;EA5JA;IAAA,4BAAA;EA4JA;;EA5JA;IAAA,4BAAA;EA4JA;;EA5JA;IAAA,4BAAA;EA4JA;;EA5JA;IAAA,4BAAA;EA4JA;;EA5JA;IAAA,4BAAA;EA4JA;;EA5JA;IAAA,cAAA;EA4JA;;EA5JA;IAAA,aAAA;EA4JA;;EA5JA;IAAA,aAAA;EA4JA;;EA5JA;IAAA,YAAA;EA4JA;;EA5JA;IAAA,gBAAA;EA4JA;;EA5JA;IAAA,iDAAA;EA4JA;;EA5JA;IAAA,gDAAA;EA4JA;;EA5JA;IAAA,gDAAA;EA4JA;;EA5JA;IAAA,gDAAA;EA4JA;;EA5JA;IAAA,mBAAA;EA4JA;;EA5JA;IAAA,aAAA;EA4JA;;EA5JA;IAAA,oBA4JA;IA5JA,qBAAA;EA4JA;;EA5JA;IAAA,mBA4JA;IA5JA,sBAAA;EA4JA;;EA5JA;IAAA,iBA4JA;IA5JA,oBAAA;EA4JA;;EA5JA;IAAA,oBAAA;EA4JA;;EA5JA;IAAA,iBAAA;EA4JA;;EA5JA;IAAA,mBAAA;EA4JA;;EA5JA;IAAA,gBAAA;EA4JA;;EA5JA;IAAA,gBAAA;EA4JA;;EA5JA;IAAA,eA4JA;IA5JA,cAAA;EA4JA;;EA5JA;IAAA,kBA4JA;IA5JA,oBAAA;EA4JA;AAAA;;AA5JA;;EAAA;IAAA,4BAAA;EA4JA;;EA5JA;IAAA,4BAAA;EA4JA;;EA5JA;IAAA,4BAAA;EA4JA;;EA5JA;IAAA,4BAAA;EA4JA;;EA5JA;IAAA,iDAAA;EA4JA;;EA5JA;IAAA,gDAAA;EA4JA;;EA5JA;IAAA,gDAAA;EA4JA;;EA5JA;IAAA,eA4JA;IA5JA,cAAA;EA4JA;AAAA;;AA5JA;EAAA,kBAAA;AA4JA;;AA5JA;EAAA,gBA4JA;EA5JA,oBA4JA;EA5JA,4BA4JA;EA5JA,qBAAA;AA4JA;;AA5JA;EAAA,sBA4JA;EA5JA,+LAAA;AA4JA;;AA5JA;EAAA,kBAAA;AA4JA;;AA5JA;EAAA,UAAA;AA4JA;;AA5JA;EAAA,SAAA;AA4JA;;AA5JA;EAAA,8BAAA;AA4JA;;AA5JA;EAAA,6BAAA;AA4JA;;AA5JA;EAAA,qBAAA;AA4JA;;AA5JA;EAAA,wBAAA;AA4JA;;AA5JA;EAAA,mBA4JA;EA5JA,+LAAA;AA4JA;;AA5JA;EAAA,oBA4JA;EA5JA,qBAAA;AA4JA;;AA5JA;EAAA,qBA4JA;EA5JA,wBAAA;AA4JA;;AA5JA;EAAA,kBA4JA;EA5JA,iBAAA;AA4JA;;AA5JA;EAAA,gBAAA;AA4JA;;AA5JA;EAAA,mCAAA;AA4JA;;AA5JA;EAAA,kBAAA;AA4JA","sourcesContent":["@import 'tailwindcss/base';\n@import 'tailwindcss/components';\n@import 'tailwindcss/utilities';\n\n/* Aplicando cores globalmente para headings */\nh1, h2, h3, h4, h5, h6 {\n  color: #475569 !important;\n}\n\n/* Aplicando a fonte Ubuntu globalmente */\nhtml, body {\n  font-family: 'Ubuntu', sans-serif;\n}\n\n/* Cor padrão para todos os headings */\nh1, h2, h3, h4, h5, h6 {\n  color: #475569;\n}\n\n@layer base {\n  h1, h2, h3, h4, h5, h6 {\n    @apply text-[#475569];\n  }\n\n  :root {\n    --background: 210 40% 98%;\n    --foreground: 222.2 84% 4.9%;\n\n    --card: 0 0% 100%;\n    --card-foreground: 222.2 84% 4.9%;\n\n    --popover: 0 0% 100%;\n    --popover-foreground: 222.2 84% 4.9%;\n\n    --primary: 221.2 83.2% 53.3%;\n    --primary-foreground: 210 40% 98%;\n\n    --secondary: 210 40% 96.1%;\n    --secondary-foreground: 222.2 47.4% 11.2%;\n\n    --muted: 210 40% 96.1%;\n    --muted-foreground: 217 19% 47%; /* #64748B */\n\n    --accent: 210 40% 96.1%;\n    --accent-foreground: 222.2 47.4% 11.2%;\n\n    --destructive: 0 84.2% 60.2%;\n    --destructive-foreground: 210 40% 98%;\n\n    --border: 214.3 31.8% 91.4%;\n    --input: 214.3 31.8% 91.4%;\n    --ring: 221.2 83.2% 53.3%;\n\n    --radius: 0.5rem;\n  }\n\n  .dark {\n    --background: 222.2 84% 4.9%;\n    --foreground: 210 40% 98%;\n\n    --card: 222.2 84% 4.9%;\n    --card-foreground: 210 40% 98%;\n\n    --popover: 222.2 84% 4.9%;\n    --popover-foreground: 210 40% 98%;\n\n    --primary: 217.2 91.2% 59.8%;\n    --primary-foreground: 222.2 47.4% 11.2%;\n\n    --secondary: 217.2 32.6% 17.5%;\n    --secondary-foreground: 210 40% 98%;\n\n    --muted: 217.2 32.6% 17.5%;\n    --muted-foreground: 215 20.2% 65.1%;\n\n    --accent: 217.2 32.6% 17.5%;\n    --accent-foreground: 210 40% 98%;\n\n    --destructive: 0 62.8% 30.6%;\n    --destructive-foreground: 210 40% 98%;\n\n    --border: 217.2 32.6% 17.5%;\n    --input: 217.2 32.6% 17.5%;\n    --ring: 212.7 26.8% 83.9%;\n  }\n}\n\n@layer base {\n  * {\n    @apply border-border;\n  }\n  body {\n    @apply bg-background text-foreground;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-feature-settings: \"rlig\" 1, \"calt\" 1;\n  }\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n.btn-primary {\n  background-color: #ffa300;\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 0.5rem;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.btn-primary:hover {\n  background-color: #e6930e;\n}\n\n.btn-secondary {\n  background-color: white;\n  color: #374151;\n  padding: 0.5rem 1rem;\n  border-radius: 0.5rem;\n  border: 1px solid #d1d5db;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.btn-secondary:hover {\n  background-color: #f3f4f6;\n}\n\n.input {\n  width: 100%;\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n  border: 1px solid #d1d5db;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 0.25rem;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
